import WagtailUserbar from './WagtailUserbar';

export default WagtailUserbar;
